
import {
  Component, Prop, Mixins,
} from 'vue-property-decorator';
import moment from 'moment';
import UtilsMixin from '@/mixins/UtilsMixin.vue';
import { CalendarEvent, ContactDetails, OperationChildUser } from '@/types';
import LeadCustomerContent from '@/components/LeadCustomerContent.vue';
import { leadRouteCode } from '@/helpers/leadCode';

moment.locale('it');

@Component({
  components: {
    LeadCustomerContent,
  },
})
export default class FullDatePickerEvent extends Mixins(UtilsMixin) {
  @Prop(Object) readonly event!: CalendarEvent;
  @Prop({ type: String, default: 'orange' }) readonly color!: string;
  @Prop(String) readonly label!: string;
  @Prop({ type: Boolean, default: false }) readonly outlined!: boolean;

  contactDetails: ContactDetails | null = null;
  getContactDetailsTimeout: number | undefined

  get eventLabel(): string {
    // Se è stata passata una label, la uso
    if (this.label) return this.label;

    return this.event?.details && 'opNumber' in this.event.details && this.event.details.opNumber
      ? `${this.event.details.opNumber}`
      : 'Commessa';
  }

  get eventDate(): string {
    return this.mDate(this.event?.date) ?? '(non definita)';
  }

  get eventTime(): string {
    if (!this.event?.startTime || !this.event?.endTime) return '(non definito)';
    return `${this.event.startTime} - ${this.event.endTime}`;
  }

  get eventInstallers(): OperationChildUser[] {
    return this.event?.details && 'installers' in this.event.details && this.event.details.installers
      ? this.event.details.installers as OperationChildUser[]
      : [];
  }

  get eventOperationId(): number | null {
    return this.event?.details && 'operationId' in this.event.details && this.event.details.operationId
      ? Number(this.event.details.operationId)
      : null;
  }

  get eventChildId(): number | null {
    return this.event?.details && 'eChildLeadId' in this.event.details && this.event.details.eChildLeadId
      ? Number(this.event.details.eChildLeadId)
      : null;
  }

  labelFor(label: string): string {
    switch (label) {
      case 'final':
        return 'Finale';
      case 'partial':
        return 'Parziale';
      default:
        return '';
    }
  }

  get installationType(): string {
    return this.event?.type === 'installation' && this.event.details.installationType ? this.labelFor(this.event.details.installationType as string) : '(Non definito)';
  }

  get installationDateConfirm(): string {
    return this.event?.type === 'installation' && this.event.details.installationDateConfirm ? 'Confermata' : 'Non confermata';
  }

  iconColor(user: OperationChildUser | null): string {
    if (user?.isDisabled === true) return 'grey lighten-2';
    if (user?.isVirtual === true) return 'light-blue lighten-2';
    if (user?.isDisabled === false) return 'success';

    return 'grey';
  }

  tooltipText(prefix: string, user: OperationChildUser | null): string {
    let result = prefix;

    if (user?.isDisabled === true) result += ' (Disattivato)';
    if (user?.isVirtual === true) result += ' (Virtuale)';

    return result;
  }

  get eventType(): string {
    return this.event?.type ?? 'generic';
  }

  async getContactDetails() {
    try {
      const contactDetails = await this.$store.dispatch('getContactDetails', { id: this.eventOperationId });

      if (contactDetails) {
        this.contactDetails = contactDetails;
      }
    } catch (error) {
      console.log(`${this.constructor.name}: getContactDetails() error =`, error); // eslint-disable-line no-console
    }

    return Promise.resolve();
  }

  onTooltipShow() {
    console.log(`${this.constructor.name}: onTooltipShow()`); // eslint-disable-line no-console

    if (this.contactDetails) return;

    this.getContactDetailsTimeout = setTimeout(() => {
      console.log(`${this.constructor.name}: onTooltipShow() timeout!`); // eslint-disable-line no-console

      this.getContactDetails();
    }, 1000);
  }

  onTooltipHide() {
    clearTimeout(this.getContactDetailsTimeout);
  }

  onGoto() {
    console.log(`${this.constructor.name}: onGoto()`); // eslint-disable-line no-console

    if (!this.eventChildId) return;

    this.$router.push({
      name: 'Lead',
      params: { code: leadRouteCode(this.eventChildId) },
      query: { tab: 'dashboard' },
    });
  }
}
